import { render, staticRenderFns } from "./VerticalSlider.vue?vue&type=template&id=48ba7b25&scoped=true"
import script from "./VerticalSlider.vue?vue&type=script&lang=ts"
export * from "./VerticalSlider.vue?vue&type=script&lang=ts"
import style0 from "./VerticalSlider.vue?vue&type=style&index=0&id=48ba7b25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ba7b25",
  null
  
)

export default component.exports